import React from "react";
import { Row, Col, ListGroup } from "react-bootstrap";
import { useMemo } from "react";
import {
  DetalleTransporteDeFecha,
  EntradaTransporteDeFecha,
} from "../../../services/transporteServicios";
import EntradaItem from "./EntradaItem";
import { ModificacionesDetalle, ordenarDetalles } from "./Modificaciones";
import { useAutoAnimate } from "@formkit/auto-animate/react";

function Entradas({
  entradas,
  onDetalleClick,
  onChequearEntrada,
  modificacionesEntradas,
  onSubirOrden,
  onBajarOrden,
}: {
  entradas: EntradaTransporteDeFecha[];
  onDetalleClick: (detalle: DetalleTransporteDeFecha) => void;
  onChequearEntrada: (
    entrada: EntradaTransporteDeFecha,
    transportado: boolean
  ) => void;
  onSubirOrden: (
    entrada: EntradaTransporteDeFecha,
    anterior: EntradaTransporteDeFecha
  ) => void;
  onBajarOrden: (
    entrada: EntradaTransporteDeFecha,
    siguiente: EntradaTransporteDeFecha
  ) => void;
  modificacionesEntradas: Map<string, ModificacionesDetalle> | undefined;
}) {
  const items = useMemo(() => {
    return ordenarDetalles(entradas, modificacionesEntradas);
  }, [entradas, modificacionesEntradas]);

  const [animationParent] = useAutoAnimate<HTMLOListElement>();

  return (
    <>
      <Row>
        <Col className="col-12">
          <ListGroup as="ol" numbered ref={animationParent}>
            {items.map((entrada, i) => (
              <EntradaItem
                entrada={entrada}
                key={entrada.id}
                onDetalleClick={onDetalleClick}
                onChequearEntrada={onChequearEntrada}
                modificacionesEntrada={modificacionesEntradas?.get(entrada.id)}
                onSubirOrden={onSubirOrden}
                onBajarOrden={onBajarOrden}
                esPrimero={i === 0}
                esUltimo={i === items.length - 1}
                anterior={i === 0 ? undefined : items[i - 1]}
                siguiente={i === items.length - 1 ? undefined : items[i + 1]}
              />
            ))}
          </ListGroup>
        </Col>
      </Row>
    </>
  );
}

export default Entradas;
